export default __webpack_public_path__ + "static/media/04_galago_m.e11b9c12.webp";